import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Container } from '@mui/material';
import { styled } from '@mui/system';
import SolutionSectionItem from './solutions/SolutionSectionItem.js';
import AOS from 'aos';
import Preloader from '../../../common/Preloader';

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 'bold',
  color: theme.palette.primary.main,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
}));

const TabPanel = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const SolutionsSection = ({ data }) => {

  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: false });
    AOS.refresh();
  }, []);

  if (!data) { return (<Preloader />); }

  const { title = "", solutions_section_items = [] } = data || {};

  return (
    <Box sx={{ py: { xs: 4, md: 16 }, textAlign: { xs: 'center', md: 'left' } }}>
      <Container maxWidth="lg" data-aos="fade-up">
        {title && <Typography variant="h3" className='homepage-section-title' sx={{ mb: { xs: 1, md: 3 } }}>
          {title}
        </Typography>}

        <Tabs className='tabs-solutions' value={activeTab} onChange={handleTabChange} centered
          sx={{ mb: { xs: 1, md: 4 }, color: 'secondary.main', gap: { xs: 1, md: 8 } }}
        >
          {solutions_section_items.map((item, index) => (
            <StyledTab key={index} label={<span className={`icon icon-${item.icon}`}></span>} />
          ))}
        </Tabs>
      </Container>

      {/* Tab Panels */}
      <Box sx={{ position: 'relative', py: { xs: 1, md: 4 }, px: { xs: 2, md: 6 } }}>
        <Container>

          {solutions_section_items.map((item, index) => (
            <TabPanel key={index} value={activeTab} index={index}>
              <SolutionSectionItem key={index} data={item} />
            </TabPanel>
          ))}

        </Container>
      </Box>

    </Box>
  );
};

export default SolutionsSection;
